module.exports = __webpack_public_path__ + "static/media/sRuleCrtRule.9869dee4.png";